export type Currency =
    string
    | 'USD'
    | 'CRC'
    | 'AUD'
    | 'AZN'
    | 'NZD'
    | 'CAD'
    | 'VES'
    | 'SGD'
    | 'COP'
    | 'GBP'
    | 'BRL'
    | 'ILS'
    | 'AED'
    | 'JMD'
    | 'MYR'
    | 'THB'
    | 'DKK'
    | 'EGP'
    | 'NOK'
    | 'SEK'
    | 'HKD'
    | 'ZAR'
    | 'CHF'
    | 'HRK'
    | 'INR'
    | 'UAH'
    | 'RUB'
    | 'BYR'
    | 'IRR'
    | 'MXN'
    | 'TWD'
    | 'TRY'
    | 'TRL'
    | 'TL'
    | 'PLN'
    | 'HUF'
    | 'BGN'
    | 'EUR'
    | 'NGN'
    | 'RON'
    | 'VND'
    | 'BDT'
    | 'XOF'
    | 'JPY'
    | 'CNY'
    | 'KRW'
    | 'ARS'
    | "CLP"
    | "SAR"


const getPreCurrency = (currency: Currency): string => {
    switch (currency) {
        case'AED':
            return 'AED';
        case'SAR':
            return 'SAR';
        case'USD':
        case'AUD':
        case'COP':
        case'MXN':
        case'CAD':
        case'SGD':
        case'SEK':
        case'HKD':
        case 'CLP':
        case 'ARS':
            return '$';
        case'NZD':
            return 'NZ$';
        case'GBP':
            return '£';
        case 'BRL':
            return 'R$';
        case'ILS':
            return '₪';
        case'THB':
            return '฿';
        case'DKK':
            return 'Kr. ';
        case'TWD':
            return 'NT$';
        case'NOK':
            return 'kr ';
        case'ZAR':
            return 'R';
        case 'CHF':
            return 'CHF ';
        case 'HRK':
            return 'kn';
        case'INR':
            return 'Rs. ';
        case'UAH':
            return ' грн.';
        case'RUB':
            return ' руб.';
        case 'BYR':
            return ' руб.';
        case'MYR':
            return 'RM ';
        case'BGN':
            return ' лв.';
        case'EUR':
            return ' €';
        case'NGN':
            return '₦';
        case'RON':
            return ' lei';
        case'BDT':
            return '৳';
        case'JPY':
            return '¥';
        case'XOF':
            return 'CFA';
        default:
            return "";
    }

};

const getPostCurrency = (currency: Currency): string => {
    switch (currency) {
        case 'CAD':
            return ' CAD';
        case 'SEK':
            return ' SEK';
        case 'PLN':
            return ' zł';
        case 'VND':
            return ' ₫';
        case 'HUF':
            return ' Ft';
        case 'IRR':
            return ' تومان';
        case 'TRY':
        case 'TRL':
            return ' TL';
        default:
            return "";
    }

};

export function formatPrice(price: string | number, currency: Currency): string {
    if(Number(price)) {
        price = Number(price).toFixed(2);
    }
    return getPreCurrency(currency) + price + getPostCurrency(currency);
}